export var componentIds = function componentIds() {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var filters = ["payment_search", "payment_type", "poliza_ramo", "poliza_company", "poliza_contratante", "poliza_asegurado", "poliza_status", "overdue_status", "due_date", "created_at", "updated_at", "reminder_sent_at"];

  if (except === null) {
    return filters;
  }

  return filters.filter(function (f) {
    return f !== except;
  });
};